import { useState, useContext } from 'react';
import Layout from '../../components/admin/Layout';
import ContextStates from '../../context/ContextStates';
import FormRepartos from '../../components/forms/formRepartos';
import FormRepartosView from '../../components/forms/formRepartosView';
import ListadoRepartos from '../../components/admin/listadoRepartos';
import FViewRepUsr from '../../components/admin/fViewRepUsr';

const Repartos = () => {
	const [tab, setTab] = useState(0)
	const { roles } = useContext(ContextStates)

	return (
		<Layout
			pagina={"Repartos"}
		>
			{(roles.includes("1")) ? (
				<div className='w-full p-5 min-h-full'>
					<div className='flex px-10 py-2 w-full'>
						<button
							type='button'
							className={`rounded p-3 text-white ${tab === 0 ? 'bg-blue-600' : 'bg-gray-600'}`}
							onClick={() => setTab(0)}
						>
							Nuevo Reparto
						</button>
						<button
							type='button'
							className={`rounded p-3 text-white ml-2 ${tab === 1 ? 'bg-blue-600' : 'bg-gray-600'}`}
							onClick={() => setTab(1)}
						>
							Listado de Repartos
						</button>
					</div>
					{tab === 0 ? (
						<FormRepartosView />
					) : (
						<ListadoRepartos />
					)}
				</div>
			):(
				<FViewRepUsr />
			)}
		</Layout>
	)
}

export default Repartos